<template>
  <div class="pa-2">
    <template v-if="filterCouriers.length > 1">
      <v-select
        v-model="couriercode"
        :items="filterCouriers"
        :label="$t('Shipping Method')"
        outline
        :hide-details="hideDetails"
        :error="error"
        :error-messages="errorMessages"
        v-validate="'required'"
        @change="$emit('input', couriercode)"
      ></v-select>
    </template>
    <div v-else-if="filterCouriers.length == 1" class="text-xs-center primary--text">
      {{ filterCouriers[0] ? filterCouriers[0].text : '' }}
    </div>
    <div v-else class="text-xs-center grey--text">
      ไม่สามารถจัดส่งได้
    </div>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: ['value', 'couriers', 'hideDetails', 'error', 'errorMessages', 'shippingtype'],
  data() {
    return {
      couriercode: null,
      courierlist: []
    }
  },
  computed: {
    filterCouriers() {
      return this.courierlist
        .filter(courier => {
          return courier.available == true
        })
        .map(el => {
          if (this.shippingtype == 'cod_charge') {
            if (
              ['TP2', 'THP', 'SCG', 'SCGC', 'SCGF', 'CJE', 'FLE', 'JNTP', 'JNTD', 'KRY'].includes(
                el.courier_code
              )
            ) {
              return {
                text: '(COD) ' + el.courier_name,
                value: el.courier_code
              }
            } else {
              return null
            }
          } else {
            return {
              text: el.courier_name,
              value: el.courier_code
            }
          }
        })
        .filter(el => {
          return el != null
        })
    }
  },
  mounted() {
    this.couriercode = this.value
    this.formatCouriers()
  },

  methods: {
    formatCouriers() {
      var couriers = []

      for (var courier in this.couriers) {
        if (this.couriers.hasOwnProperty(courier)) {
          couriers.push(this.couriers[courier])
        }
      }

      if (couriers.length == 1) {
        this.couriercode = couriers[0].courier_code
        this.$emit('input', this.couriercode)
      }

      this.courierlist = couriers
    }
  },
  watch: {
    couriers(newVal, oldVal) {
      if (newVal != oldVal) {
        this.formatCouriers()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/SelectShippopCourier.vue